import client from './client';

export interface Job {
  id: number;
  title: string;
  description?: string;
  company?: string;
  salary_from?: number;
  salary_to?: number;
  category: 'office' | 'service' | 'construction' | 'education' | 'medical' | 'government' | 'seasonal' | 'other';
  employment_type: 'full' | 'part' | 'temporary' | 'remote';
  contact_phone?: string;
  contact_name?: string;
  address?: string;
  is_active: boolean;
  views_count: number;
  created_at: string;
}

export interface JobCreatePayload {
  title: string;
  description?: string;
  company?: string;
  salary_from?: number;
  salary_to?: number;
  category: string;
  employment_type: string;
  contact_phone?: string;
  contact_name?: string;
  address?: string;
}

export interface JobStats {
  total: number;
  active: number;
  by_category: Record<string, number>;
}

export const jobsApi = {
  list: (params?: Record<string, any>) =>
    client.get<Job[]>('/api/admin/jobs', { params }),

  create: (data: JobCreatePayload) =>
    client.post('/api/admin/jobs', data),

  update: (id: number, data: Partial<JobCreatePayload>) =>
    client.patch(`/api/admin/jobs/${id}`, data),

  delete: (id: number) =>
    client.delete(`/api/admin/jobs/${id}`),

  stats: () =>
    client.get<JobStats>('/api/admin/jobs/stats'),
};
